<template>
    <div class="flex-col" style="min-height: 100vh;">
        <header class="justify-space-between header">
            <nav class="navbar flex-row p-0 logo-only">
                <Logo />
            </nav>
        </header>
        <CookieBanner />
        <div class="mt-12 mb-60 login-wrapper">
            <div v-if="loading" class="mt-60 loader loader-md"></div>
            <Login v-else-if="state === 'signin'" @stateChanged="stateChanged" />
            <ResetPassword v-else-if="state === 'reset-pw'" @stateChanged="stateChanged" />
            <Registration v-else-if="state === 'register'" @stateChanged="stateChanged" />
        </div>
        <Footer />
    </div>
</template>

<script>

import Logo from "../components/header/Logo.vue";
import Login from "../components/login/Login.vue";
import CookieBanner from "../components/cookieBanner/CookieBanner.vue"
import Footer from "../components/Footer.vue";

import ResetPassword from "../components/login/ResetPassword.vue";
import Registration from "../components/login/Registration.vue";

export default {
    data: () => {
        return {
            loading: false,
            state: "signin",
        }
    },
    components: {
        Logo,
        Footer,
        Login,
        CookieBanner,
        ResetPassword,
        Registration,
    },
    methods: {
        stateChanged(state) {
            this.state = state
        }
    },
}

</script>